import { CameraType } from '@EcamModel/controllers/ICameraHttpController';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import AddGeoZones from '../details/components/AddGeoZones';
import EditGeoZones from '../details/components/EditGeoZones';
import AddGeoZonesCameraPTZ from '../details/components/tabsGeozonesDetail/ptz/upsertGeoZones/components/AddGeoZonesPTZ';
import EditGeoZonesPTZ from '../details/components/tabsGeozonesDetail/ptz/upsertGeoZones/components/EditGeoZonesPTZ';
import AddGeoZonesSP111 from '../details/components/tabsGeozonesDetail/sp111/upsertGeoZones/AddGeoZonesSP111';
import EditGeoZonesSP111 from '../details/components/tabsGeozonesDetail/sp111/upsertGeoZones/EditGeoZonesSP111';

export const typeTextMap: { [key in CameraType]: string } = {
    [CameraType.PTZ]: 'ptz',
    [CameraType.Solar]: 'solar',
    [CameraType.SP111]: 'sp111',
    [CameraType.PMC8266]: 'pmc8266',
};

const UpsertGeoZonesHandlerRouter: FC = () => {
    const upsertMapping: { [key: string]: FC } = {
        [`add-${typeTextMap[CameraType.Solar]}`]: AddGeoZones,
        [`edit-${typeTextMap[CameraType.Solar]}`]: EditGeoZones,
        [`add-${typeTextMap[CameraType.PTZ]}`]: AddGeoZonesCameraPTZ,
        [`edit-${typeTextMap[CameraType.PTZ]}`]: EditGeoZonesPTZ,
        [`add-${typeTextMap[CameraType.SP111]}`]: AddGeoZonesSP111,
        [`edit-${typeTextMap[CameraType.SP111]}`]: EditGeoZonesSP111,
        [`add-${typeTextMap[CameraType.PMC8266]}`]: AddGeoZones,
        [`edit-${typeTextMap[CameraType.PMC8266]}`]: EditGeoZones,
    };

    const { type, geoZoneId } = useParams<{ type: string; geoZoneId?: string }>();

    const action = geoZoneId ? 'edit' : 'add';

    const UpsertComponent = upsertMapping[`${action}-${type}`];
    return UpsertComponent ? <UpsertComponent /> : null;
};

export default UpsertGeoZonesHandlerRouter;
